<ng-container *ngIf="hasPermission$ | async; else moduleNotPermitted">
    <app-job-invoices-deposit [job]="job" (invoiceChange)="onInvoiceChange()"></app-job-invoices-deposit>

    <app-job-invoices-contract-price
        *ngIf="job.InvoiceMethod === 0"
        [job]="job"
        (invoiceChange)="onInvoiceChange()"></app-job-invoices-contract-price>

    <app-job-invoices-cost-plus
        *ngIf="job.InvoiceMethod === 1"
        [job]="job"
        (invoiceChange)="onInvoiceChange()"
        (showingCustomFooter)="onCostPlusCustomFooterShowing($event)"></app-job-invoices-cost-plus>

    <app-job-invoices-completion-percent
        *ngIf="job.InvoiceMethod === 2"
        [job]="job"
        (invoiceChange)="onInvoiceChange()"></app-job-invoices-completion-percent>

    <help-note-wrapper
        [title]="'helpNotes.jobs.invoicing.title' | translate"
        url="https://help.buildxact.com/en/collections/1745491-job-management#invoices"
        footer="Read more in our FAQ’s"
        setting="NoteJobInvoiceList"
        [expanded]="true"
        [videoList]="'helpNotes.jobs.invoicing.videos' | translate">
        {{ 'helpNotes.jobs.invoicing.text' | translate }}
    </help-note-wrapper>

    <div class="padding-20"></div>

    <footer class="fixed-footer hidden-print" *ngIf="showFooter">
        <div class="panel-tools" style="z-index: 999">
            <a
                class="btn btn-info btn-o btn-sm"
                tooltip="Show details"
                container="body"
                placement="left"
                *ngIf="!showSummaryDetails"
                (click)="showSummaryDetails = !showSummaryDetails">
                <i class="ti-angle-up"></i>
            </a>
            <a
                class="btn btn-info btn-o btn-sm"
                tooltip="Hide details"
                container="body"
                placement="left"
                *ngIf="showSummaryDetails"
                (click)="showSummaryDetails = !showSummaryDetails">
                <i class="ti-angle-down"></i>
            </a>
        </div>
        <div class="footer-inner">
            <div *ngIf="!showSummaryDetails">
                <ng-container [ngSwitch]="job.InvoiceMethod">
                    <ng-container *ngSwitchCase="1"><ng-container *ngTemplateOutlet="costPlusFooter"></ng-container></ng-container>
                    <ng-container *ngSwitchDefault><ng-container *ngTemplateOutlet="defaultFooter"></ng-container></ng-container>
                </ng-container>
            </div>
            <div *ngIf="showSummaryDetails">
                <ng-container [ngSwitch]="job.InvoiceMethod">
                    <ng-container *ngSwitchCase="1"><ng-container *ngTemplateOutlet="costPlusFooterDetails"></ng-container></ng-container>
                    <ng-container *ngSwitchDefault><ng-container *ngTemplateOutlet="defaultFooterDetails"></ng-container></ng-container>
                </ng-container>
            </div>
        </div>
    </footer>

    <ng-template #defaultFooter>
        <div class="row" style="line-height: 24px">
            <div class="col-xs-3 text-center">
                <div class="form-group text-large margin-bottom-5 margin-top-5">Contract (Ex)</div>
                <h4>{{ job.ContractTotal | bxCurrency }}</h4>
            </div>
            <div class="col-xs-2 text-center">
                <div class="form-group text-large margin-bottom-5 margin-top-5">{{ 'general.variations' | translate }} (Ex)</div>
                <h4>{{ job.VariationTotal | bxCurrency }}</h4>
            </div>
            <div class="col-xs-2 text-center">
                <div class="form-group text-large margin-bottom-5 margin-top-5">Invoiced (Ex)</div>
                <h4>
                    {{ job.PaymentTotal | bxCurrency }}
                    <small>
                        <span
                            class="label"
                            [ngClass]="{
                                'label-info': job.InvoicedPercent < 100,
                                'label-success': job.InvoicedPercent === 100,
                                'label-warning': job.InvoicedPercent > 100,
                            }"
                            *ngIf="job.InvoicedPercent !== 0">
                            {{ job.InvoicedPercent }}%
                        </span>
                    </small>
                </h4>
            </div>
            <div class="col-xs-2 text-center">
                <div class="form-group text-large margin-bottom-5 margin-top-5">{{ taxCode }}</div>
                <h4>{{ job.PaymentTax | bxCurrency }}</h4>
            </div>
            <div class="col-xs-2 text-center">
                <div class="form-group text-large margin-bottom-5 margin-top-5" tooltip="Amount you haven't invoiced yet" container="body">
                    Remaining (Ex)
                </div>
                <h4>
                    <strong>{{ job.InvoicedRemainder | bxCurrency }}</strong
                    >&nbsp;
                </h4>
            </div>
        </div>
    </ng-template>

    <ng-template #costPlusFooter>
        <div class="row" style="line-height: 24px">
            <div class="col-xs-4 text-center">
                <div class="form-group text-large margin-bottom-5 margin-top-5">Actual (Ex)</div>
                <h4>{{ job.ActualTotal | bxCurrency }}</h4>
            </div>
            <div class="col-xs-4 text-center">
                <div class="form-group text-large margin-bottom-5 margin-top-5">Invoiced (Ex)</div>
                <h4>
                    {{ job.PaymentTotal | bxCurrency }}
                    <small>
                        <span
                            class="label"
                            [ngClass]="{
                                'label-info': job.InvoicedPercent < 100,
                                'label-success': job.InvoicedPercent === 100,
                                'label-warning': job.InvoicedPercent > 100,
                            }"
                            *ngIf="job.InvoicedPercent !== 0">
                            {{ job.InvoicedPercent }}%
                        </span>
                    </small>
                </h4>
            </div>
            <div class="col-xs-4 text-center">
                <div class="form-group text-large margin-bottom-5 margin-top-5">Variance (Ex)</div>
                <h4>
                    <strong>{{ job.InvoicedRemainder | bxCurrency }}</strong
                    >&nbsp;
                </h4>
            </div>
        </div>
    </ng-template>

    <ng-template #defaultFooterDetails>
        <div class="row" style="line-height: 24px">
            <div class="col-xs-3 text-center">
                <div class="form-group text-large margin-bottom-5 margin-top-5">Contract (Ex)</div>
                <h4>{{ job.ContractTotal | bxCurrency }}</h4>
            </div>
            <div class="col-xs-2 text-center">
                <div class="form-group text-large margin-bottom-5 margin-top-5">{{ 'general.variations' | translate }} (Ex)</div>
                <h4>{{ job.VariationTotal | bxCurrency }}</h4>
            </div>
            <div class="col-xs-2 text-center">
                <div class="form-group text-large margin-bottom-5 margin-top-5">Invoiced (Ex)</div>
                <h4>
                    {{ job.PaymentTotal | bxCurrency }}
                    <small>
                        <span
                            class="label"
                            [ngClass]="{
                                'label-info': job.InvoicedPercent < 100,
                                'label-success': job.InvoicedPercent === 100,
                                'label-warning': job.InvoicedPercent > 100,
                            }"
                            *ngIf="job.InvoicedPercent !== 0">
                            {{ job.InvoicedPercent }}%
                        </span>
                    </small>
                </h4>
                <h5>Invoiced: {{ job.PaymentTotal - depositRefunded | bxCurrency }}</h5>
                <h5>Refunded: {{ depositRefunded | bxCurrency }}</h5>
            </div>
            <div class="col-xs-2 text-center">
                <div class="form-group text-large margin-bottom-5 margin-top-5">{{ taxCode }}</div>
                <h4>{{ job.PaymentTax | bxCurrency }}</h4>
            </div>
            <div class="col-xs-2 text-center">
                <div class="form-group text-large margin-bottom-5 margin-top-5" tooltip="Amount you haven't invoiced yet" container="body">
                    Remaining (Ex)
                </div>
                <h4>
                    <strong>{{ job.InvoicedRemainder | bxCurrency }}</strong
                    >&nbsp;
                </h4>
            </div>
        </div>
    </ng-template>

    <ng-template #costPlusFooterDetails>
        <div class="row" style="line-height: 24px">
            <div class="col-xs-4 text-center">
                <div class="form-group text-large margin-bottom-5 margin-top-5">Actual (Ex)</div>
                <h4>{{ job.ActualTotal | bxCurrency }}</h4>
            </div>
            <div class="col-xs-4 text-center">
                <div class="form-group text-large margin-bottom-5 margin-top-5">Invoiced (Ex)</div>
                <h4>
                    {{ job.PaymentTotal | bxCurrency }}
                    <small>
                        <span
                            class="label"
                            [ngClass]="{
                                'label-info': job.InvoicedPercent < 100,
                                'label-success': job.InvoicedPercent === 100,
                                'label-warning': job.InvoicedPercent > 100,
                            }"
                            *ngIf="job.InvoicedPercent !== 0">
                            {{ job.InvoicedPercent }}%
                        </span>
                    </small>
                </h4>
                <h5>Invoiced: {{ job.PaymentTotal - depositRefunded | bxCurrency }}</h5>
                <h5>Refunded: {{ depositRefunded | bxCurrency }}</h5>
            </div>
            <div class="col-xs-4 text-center">
                <div class="form-group text-large margin-bottom-5 margin-top-5">Variance (Ex)</div>
                <h4>
                    <strong>{{ job.InvoicedRemainder | bxCurrency }}</strong
                    >&nbsp;
                </h4>
            </div>
        </div>
    </ng-template>
</ng-container>

<ng-template #moduleNotPermitted>
    <app-bx-permission-notification></app-bx-permission-notification>
</ng-template>
